/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Mic_CancelInputs */

const en_us2_coach_mic_cancel = /** @type {(inputs: Coach_Mic_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel recording`)
};

const pt_br2_coach_mic_cancel = /** @type {(inputs: Coach_Mic_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar gravação`)
};

const es_419_coach_mic_cancel = /** @type {(inputs: Coach_Mic_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar grabación`)
};

const pt_pt2_coach_mic_cancel = /** @type {(inputs: Coach_Mic_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar gravação`)
};

const fr_fr2_coach_mic_cancel = /** @type {(inputs: Coach_Mic_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuler l'enregistrement`)
};

const de_de2_coach_mic_cancel = /** @type {(inputs: Coach_Mic_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aufnahme abbrechen`)
};

const it_it2_coach_mic_cancel = /** @type {(inputs: Coach_Mic_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annulla registrazione`)
};

/**
* | output |
* | --- |
* | "Cancel recording" |
*
* @param {Coach_Mic_CancelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_mic_cancel = /** @type {((inputs?: Coach_Mic_CancelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Mic_CancelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_mic_cancel(inputs)
	if (locale === "es-419") return es_419_coach_mic_cancel(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_mic_cancel(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_mic_cancel(inputs)
	if (locale === "de-DE") return de_de2_coach_mic_cancel(inputs)
	if (locale === "it-IT") return it_it2_coach_mic_cancel(inputs)
	return en_us2_coach_mic_cancel(inputs)
});
export { coach_mic_cancel as "coach-mic.cancel" }